// extracted by mini-css-extract-plugin
module.exports = {"detail_new":"styles_detail_new__1mb2P","header":"styles_header__2lYG5","back":"styles_back__vifTO","title":"styles_title__3RGUO","content":"styles_content__7rfE-"};